import React, {memo} from 'react'
import {Button, Confirm, Dropdown, Icon, Table} from 'semantic-ui-react'
import {withErrorHandling, withHelmet, withMeData, withPropsPresent} from '../../hoc'
import {userAccount, userIsAdminForAccount} from '../../util'
import {regenerateApiKey} from '../../backend'
import {useSafeState} from '../../hook'

const _Accounts = (props) => {
  const {
    me,
    accounts = [],
    navigate,
    basePath = '/c/account/accounts',
    regenerateApiKey,
    mutateMe,
    children
  } = props

  const [state, setState] = useSafeState({confirming: ''})

  const onLeave = (e, account) => {
    e.preventDefault()
    navigate(`${basePath}/${account.id}/leave`)
  }

  const onRegenerateApiKey = async (e, account) => {
    e.preventDefault()
    setState({confirming: account.id})
  }

  const onConfirmRegenerateApiKey = async () => {
    await regenerateApiKey(state.confirming)
    mutateMe()
    setState({confirming: ''})
  }

  const onCancelConfirmRegenerateApiKey = () => {
    setState({confirming: ''})
  }

  const isAdminForAtLeastOneAccount = accounts.some(a => userIsAdminForAccount(me, a))

  return (
    <div>
      <Confirm content='Are you sure? This will disable access for API callers using existing key.'
               confirmButton={() => <Button primary content='Confirm' onClick={onConfirmRegenerateApiKey}/>}
               onCancel={onCancelConfirmRegenerateApiKey}
               data-testid='api-key-regen-confirmation'
               open={!!state.confirming}
      />
      <Table celled collapsing>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width='3'>Account</Table.HeaderCell>
            <Table.HeaderCell width='3'>API Key</Table.HeaderCell>
            <Table.HeaderCell width='3'>Admin</Table.HeaderCell>
            {
              isAdminForAtLeastOneAccount && (<Table.HeaderCell></Table.HeaderCell>)
            }
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            accounts.map((a) => (
              <Table.Row key={a.id}  data-test='accounts-account-table-row'>
                <Table.Cell verticalAlign='top' width='4' data-test='account-name'>{a.name}</Table.Cell>
                <Table.Cell verticalAlign='top' width='4' data-test='account-api-key'>{a.apiKey}</Table.Cell>
                <Table.Cell verticalAlign='top' width='4' data-test='account-admin'>{userIsAdminForAccount(me, a) ? 'Yes' : 'No'}</Table.Cell>
                {
                  isAdminForAtLeastOneAccount && (
                    <Table.Cell verticalAlign='top' width='2' textAlign='center'>
                      <Dropdown icon='setting' data-test='account-menu'>
                        <Dropdown.Menu>
                          {
                            a.admins.length >= 1 && (
                              <Dropdown.Item as='a' onClick={(e) => onLeave(e, a)} data-test='close-account-menu-item'>
                                <Icon name='remove'/> Leave Account
                              </Dropdown.Item>
                            )
                          }
                          {
                            userIsAdminForAccount(me, a) && (
                              <Dropdown.Item as='a' onClick={(e) => onRegenerateApiKey(e, a)} data-test='regen-api-key-menu-item'>
                                <Icon name='sync'/> Regenerate API Key
                              </Dropdown.Item>
                            )
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </Table.Cell>
                  )
                }
              </Table.Row>
            ))
          }
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan='4'>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
      {children}
    </div>
  )
}

let Accounts = (props) => {
  const {handleError} = props
  const accountId = userAccount(props.me, true)
  props = {...props, accountId, accounts: props.me.accounts, regenerateApiKey: handleError(regenerateApiKey)}
  return (<_Accounts {...props}/>)
}

Accounts = withHelmet(Accounts, 'Accounts')
Accounts = withPropsPresent(Accounts, ['me'])
Accounts = withMeData(Accounts, 'Loading profile...')
Accounts = withErrorHandling(Accounts)
Accounts = memo(Accounts)

export {Accounts, _Accounts}

export default Accounts